module.exports = __webpack_public_path__ + "media/images/ultra-652285628aa1a96a2e52b86ef7ef2463.webp";